import ChapterNextFaviconIco from "@/shared/brand/assets/chapternext/favicon.ico";
import ChapterNextFaviconSvg from "@/shared/brand/assets/chapternext/favicon.svg";
import OneCareerFaviconIco from "@/shared/brand/assets/onecareer/favicon.ico";
import OneCareerFaviconSvg from "@/shared/brand/assets/onecareer/favicon.svg";
import type { Brand } from "./brand";

const FAVICONS: Record<Brand, { ico: string; svg: string }> = {
  onecareer: { ico: OneCareerFaviconIco, svg: OneCareerFaviconSvg },
  chapternext: { ico: ChapterNextFaviconIco, svg: ChapterNextFaviconSvg },
};

function iconLink(attributes: Record<string, string>): HTMLLinkElement {
  const link = document.createElement("link");
  link.rel = "icon";
  for (const [name, value] of Object.entries(attributes)) {
    link.setAttribute(name, value);
  }
  return link;
}

export function linkBrandFavicon(brand: Brand): void {
  const { ico, svg } = FAVICONS[brand];
  document.head.append(
    // Safari reads SVG favicons only from version 26, so the ICO stays.
    // Without `sizes` on it, Chrome picks the ICO over the SVG.
    iconLink({ href: ico, sizes: "32x32" }),
    iconLink({ href: svg, type: "image/svg+xml" }),
  );
}
